import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const ButtonGroup = props => {
  const {
    className,
    theme,
    width,
    resource,
    children,
    record,
    vertical,
    tag: Tag,
    ...attributes
  } = props

  const classes = classNames(
    className,
    theme['button-group'],
    vertical ? theme['vertical'] : theme['horizontal'],
  )
  const childrenWithProps = React.Children.map(children, child =>
    React.cloneElement(child, {
      record,
      resource,
    }),
  )

  return (
    <Tag {...attributes} className={classes}>
      {childrenWithProps}
    </Tag>
  )
}

ButtonGroup.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  'aria-label': PropTypes.string,
  className: PropTypes.string,
  theme: PropTypes.object,
  role: PropTypes.string,
  vertical: PropTypes.bool,
}

ButtonGroup.defaultProps = {
  tag: 'div',
  role: 'group',
}

export default ButtonGroup



// WEBPACK FOOTER //
// ./ui/Button/ButtonGroup.js